import { Col, Grid, Row } from "antd";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { TypeColorNames } from "../../../theme/colors";
import { TypographyTypes } from '../../../theme/typography';
import Typography from "../../shared/typography/Typography";

interface StyledDescriptionProps {
  image?: any;
  style?: any;
  position?: "RIGHT" | "LEFT";
  color: TypeColorNames;
}

export interface IDescription {
  color: TypeColorNames;
  image?: any;
  title: String;
  text: String;
  style?: any;
  position?: "RIGHT" | "LEFT";
  idForAnchor?: string;
}

const DEFAULT_COLOR = "darkBackground";

const StyledDescription = styled.div<StyledDescriptionProps>`
  .colorful {
    display: flex;
    align-items: center;
    background-color: ${props => props.color};

    ${({ position }) => position === "LEFT" && `flex-direction: row-reverse;`}

    img {
      height: 100%;
      max-height: 390px;
      ${({ position }) =>
        position === "RIGHT" ? `margin-left: -120px;` : `margin-right: -120px;`}
      padding: 60px 0px;
      margin-top: 45px;
      margin-bottom: 82px;

      @media only screen and (max-width: 768px) {
        max-height: 300px;
      }
    }

    @media only screen and (max-width: 768px) {
      justify-content: center;
      background-color: transparent;
      background-image: linear-gradient(
        to right,
       ${(props) => props.theme.colors.background} 0%,
       ${(props) => props.theme.colors.background} 50%,
        ${props => props.color} 50%
      );

      img {
        margin-left: 0px;
        margin-right: 0px;
      }
    }
  }

  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 16px 16px 16px 24px;
    background-color: ${(props) => props.theme.colors.background};
    padding-left: 80px;

    @media only screen and (max-width: 768px) {
      background-color: transparent;
      padding-left: 32px;
    }

    @media only screen and (min-width: 768px) {
      ${({ position }) =>
        position === "LEFT" ? `padding-left: 136px;` : `padding-right: 136px;`}
    }

    @media only screen and (min-width: 1920px) {
      padding: 16px 145px 16px 160px;
    }
  }
`;

// const MOBILE_TITLE_FONT = 'heading5';
// const DESKTOP_TITLE_FONT = 'heading4';

// const MOBILE_DESCRIPTION_FONT = 'body3';
// const DESKTOP_DESCRIPTION_FONT = 'body2';

const { useBreakpoint } = Grid;

const Description = ({
  image,
  title,
  text,
  style,
  color,
  position,
  idForAnchor,
}: IDescription) => {
  const screens = useBreakpoint();
  const [fontType, setFontType] = useState<TypographyTypes>('heading4')
  
  useEffect(() => {
    if (screens.xxl || screens.xl || screens.lg || screens.md) {
      setFontType('heading4')
    } else {
      setFontType('heading5')
    }
  });

  return (
    <StyledDescription color={color} style={style} position={position} id={idForAnchor}>
      <Row
        style={{ flexDirection: position === "RIGHT" ? "row" : "row-reverse" }}
      >
        <Col
          xs={{ span: 24, order: 2 }}
          sm={{ span: 24, order: 2 }}
          md={{ span: 16, order: 1 }}
          className="text"
        >
          <Typography type={fontType} color="title" style={{maxWidth: '660px'}}>
            {title}
          </Typography>
          <br />
          <Typography type="body2" color="body" style={{maxWidth: '660px'}}>
            {text}
          </Typography>
        </Col>
        <Col
          xs={{ span: 24, order: 1 }}
          sm={{ span: 24, order: 1 }}
          md={{ span: 8, order: 2 }}
          className="colorful"
          color={color}
        >
          <img src={image} alt="section" style={{maxWidth: '100%', height: 'auto', objectFit: 'contain'}}/>
        </Col>
      </Row>
    </StyledDescription>
  );
};

Description.defaultProps = {
  color: DEFAULT_COLOR,
};

Description.randomPosition = (): "RIGHT" | "LEFT" => {
  const positions: Array<"RIGHT" | "LEFT"> = ["RIGHT", "LEFT"];

  return positions[Math.floor(Math.random() * positions.length)];
};

export default Description;
